import React, { useEffect, useState } from "react";
import {
    Row,
    Col,
    Card,
    CardBody,
    Button,
    Label
} from "reactstrap";
import { AvForm, AvField } from 'availity-reactstrap-validation';
import Select from "react-select";
import FileUpload from "components/Common/file-upload/file-upload.component";
import Language from "Enums/Language"
import SelectOptions from "components/SelectOptions"
import FinishingTypesService from "services/Admin/FinishingTypesService"
import UnitTypesService from "services/Admin/UnitTypesService"
import PaymentService from "services/Admin/PaymentService"
import CategoriesService from "services/Admin/CategoriesService"
import BuildingService from "services/Admin/BuildingService"
import PropertyService from "services/Admin/PropertyService"
import { SuccessCreated, SuccessOk } from "configs/statusCode";
import { toast } from "react-toastify";
import { adminPrefix } from "configs/routePrefix";
import { floors, bathrooms, bedrooms, years, payment_methods } from "Enums/fixedData"
import UnitOptions from "Enums/UnitOptions"
import CompoundService from "services/Admin/CompoundService"
import PaymentPlanService from "services/Admin/PaymentPlanService"
import PayementYearService from "services/Admin/PayementYearService"
import PriceInput from "components/PriceInput"
import CurrencyInput from 'react-currency-input-field';

const languages = ["en", "ar", "zh", "ru"]


const PaymentPlan = ({ formData, setFormData, index, payment_plans, setPaymentOptions, yearsData, paymentPlanOptionsData }) => {
    const [yearsptions, setYearsOptions] = useState([])
    const [yearsDataOptions, setYearsDataOptions] = useState([])
    const [selected, setSelected] = useState(null)
    const [payPlans, setPayPlans] = useState([])
    const [paymentPlanOptions, setPaymentPlanOptions] = useState([])

    useEffect(() => {
   
         let arr = []
        if (formData.payment_plans[index].id) {
            formData.payment_plans.forEach(plan => {
                if (arr.find(item => item ?.id !== plan ?.id ?.value) || arr.length === 0) {
                    if (arr.find(item => item ?.id === plan ?.id ?.value)) {
                        const index = arr.findIndex(item => item ?.id === plan ?.id ?.value)
                        arr[index] = {
                            id: arr[index].id,
                            length: arr[index].length + 1
                        }

                    } else {
                        arr.push({ id: plan ?.id ?.value, length: 1 })

                    }
                } else {
                    const index = arr.findIndex(item => item ?.id === plan ?.id ?.value)
                    arr[index] = {
                        id: arr[index].id,
                        length: arr[index].length + 1
                    }
                }
            })

            if (arr.length !== 0) {
                const filterUpdated = yearsDataOptions.filter((year) => !arr.some((arrItem) => arrItem.length === year.years.length && arrItem.id === year.id))
                const updatedpayment = paymentPlanOptionsData.filter(({ value }) => filterUpdated.some(({ id }) => value === id))
                setPaymentOptions([...updatedpayment])
              
            }
      
 

        }
    }, [formData.payment_plans])

    useEffect(() => {
        setPayPlans(payment_plans)
    }, [payment_plans])
    useEffect(() => {
         setPaymentPlanOptions([...paymentPlanOptionsData])
    }, [paymentPlanOptionsData])

    useEffect(() => {
        setYearsDataOptions(yearsData)
    }, [yearsData])


    useEffect(() => {
        if (selected) {
            const data = yearsDataOptions.filter((option, index) => option.id === selected ?.value)
            const updated = data[0].years.map(item => {
                return {
                    label: item.years,
                    value: item.id,
                }
            })
            const arr = []
            payPlans.forEach(plan => {
                if (plan ?.id ?.label === selected ?.label)
                    arr.push({
                        id: plan ?.id,
                        year_id: plan ?.year_id
                    })
            })

            const filterUpdated = updated ?.filter(({ label: l1 }) => !arr.some(({ year_id: l2 }) => l2 ?.label === l1))
      
            setYearsOptions(filterUpdated)
        }
    }, [selected])
    return (
        <Row key={index}>
                 <Col md={12} className="d-flex flex-row-reverse">
                   {index!==0? <button className="btn btn-danger" type="button" onClick={() => {
                         // setYearsOptions(data =>  data.map(item => {
                        //         if (item.id.value !== formData.payment_plans[index] ?.id ?.value) {
                        //             return item
                        //         }
                        //     })
                        // )
                        if (formData.payment_plans[index] ?.id ?.value) {
                            setPaymentOptions((data) => {
                                 const option = data.find(item => item.value === formData.payment_plans[index].id.value)
                                 if (option) {
                                     return data
                                } else {
                                    return [...data, formData.payment_plans[index].id]
                                }
                            })

                        }
                        const updated = formData.payment_plans.filter((plan, planIndex) => {
                            return planIndex !== index
                        })

                        setFormData({ ...formData, payment_plans: [...updated] });

                    }} >X</button>:null}
                </Col>
            <Col md={6}>
                <label>Plan (Required)</label>
                <Select
                    placeholder='Select'
                    options={paymentPlanOptions}
                    className='mb-3 '
                    onChange={(data) => {
                        const updated = formData.payment_plans.map((item, itemIndex) => {
                            if (itemIndex === index) {
                                return {
                                    ...item,
                                    id: data,
                                    year_id:null
                                }
                            } else {
                                return item
                            }

                        })
                        setSelected(updated[index].id)
                        setFormData({ ...formData, payment_plans: updated });
                    }}
                    value={formData.payment_plans[index].id}

                />
            </Col>
            <Col md={6}>
                <label>Years (Required)</label>
                <Select
                    placeholder='Select'
                    options={yearsptions}
                    className='mb-3 '
                    onChange={(data) => {
                        const updated = formData.payment_plans.map((item, itemIndex) => {
                            if (itemIndex === index) {
                                return {
                                    ...item,
                                    year_id: data
                                }
                            } else {
                                return item
                            }

                        })
                        setFormData({ ...formData, payment_plans: updated });
                    }}
                    value={formData.payment_plans[index].year_id}

                />
            </Col>
            {/* <Col md={6} className="price-input"  >
                <Label>Total Price</Label>
                <CurrencyInput
                    id="totalPrice"
                    className="mb-3"
                    name={`total${index}`}
                    placeholder={"Price"}
                    value={formData.payment_plans[index].total}
                    allowNegativeValue={false}
                    decimalsLimit={2}
                    onValueChange={(value, name) => {
                        const updated = formData.payment_plans.map((item, itemIndex) => {
                            if (index === itemIndex) {
                                return { ...item, total: value }
                            } else {
                                return item
                            }
                        })
                        setFormData({ ...formData, payment_plans: [...updated] });
                    }}
                />
            </Col> */}
        </Row>
    )
}
export default PaymentPlan
